import { formatPrice } from '../../lib/utils/currency';
import useCurrentCurrency from '../hooks/useCurrentCurrency';
import { useStore } from '../hooks/useStore';
import useTranslation from '../hooks/useTranslation';
import Devices from '../components/icons/Devices';
import Bonus from './Bonus';

const SelectedDevice = () => {
  const selectedModel = useStore((state) => state.selectedModel);
  const priceQuote = useStore((state) => state.priceQuote);
  const campaign = useStore((state) => state.campaign);
  const currency = useCurrentCurrency();
  const translations = useTranslation();

  const price = priceQuote?.OfferedPrice || selectedModel?.Price || 0;
  const bonus =
    priceQuote?.PotentialCampaign?.DealBonusInclVat ||
    // TODO: Using campaign?.amount is a hack until Foxway has solved their calculation issues with selectedModel?.PotentialBonus?.DealBonus
    (selectedModel && campaign?.amount) ||
    0;

  return (
    <section className="flex gap-4 flex-col sm:flex-row">
      <div className="h-28 aspect-square flex items-center justify-center bg-white rounded-md">
        {selectedModel?.PictureUrl ? (
          <img
            alt=""
            className="max-w-full max-h-full"
            src={selectedModel?.PictureUrl}
          />
        ) : (
          <Devices fill="#d2d2d2" className="max-w-full max-h-full" />
        )}
      </div>
      <div className="flex flex-1 flex-col md:flex-row md:content-between sm:text-left text-center gap-1 py-2">
        <div className="flex grow justify-center flex-col sm:items-start items-center">
          {selectedModel?.ProductName && (
            <p className="text-base font-samsungOneBold">
              {selectedModel.ProductName}
            </p>
          )}
          {bonus > 0 && (
            <>
              <p className="text-sm">
                {translations['priceEstimate']}:{' '}
                <span className="text-samsungBlue font-bold">
                  {formatPrice(price, currency)}
                </span>
              </p>
              <p className="text-sm">
                {translations['priceCampaign']}:{' '}
                <Bonus className="font-bold">
                  +{formatPrice(bonus, currency)}
                </Bonus>
              </p>
            </>
          )}
        </div>
        <div className="flex justify-center flex-col">
          <p className="text-3xl samsungOneBold">
            {formatPrice(price + bonus, currency)}
          </p>
          {price > 0 && (
            <p className="text-xs italic">{translations['priceGrading']}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default SelectedDevice;
